import React, { useState } from "react";
// import "./index.css";

// components imports
import { formatAccountNumber } from "../../_utils/FormatAccountNumber";

// images imports
import CommonBankLogo from "../../_utils/CommonBankLogo";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import SmallPopup from "../../_utils/CommonSmallPopup";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import { createFieldForceAccount } from "../../../redux/features/accounts/fieldForceAccount";
import FieldForceAccountAssociatePopup from "../../../containers/FieldForceAccount/FieldForceAccountViewAll/FieldForceAccountAssociatePopup";
import ICONS from "../../../assets/Icons";
import ConfidentialCard from "../../../components/_utils/TransactionCommonComponents/ConfidentialCard";
import TEXT from "../../../utils/globalText";
import CommonLayout from "../../_utils/CommonLayout";

const FieldForceConfirmAccount = React.memo(
  ({
    payload,
    selectedFields,
    bankAccountName,
    setShowModalPopup,
    showModalPopup,
    bankUserInfo,
    recipients,
    flow,
    remPan,
    setRemPan,
    createFieldForceAccountLoading,
    manualVirtualAccount,
  }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const categories = useSelector(
      (state) => state.beneAllVerification.beneTransCategories.categories,
    );

    const [activeType, setActiveType] = useState("Pan");
    const [remAccount, setRemAccount] = useState("");
    const [remIFSC, setRemIFSC] = useState("");

    const handleCloseModal = () => {
      setShowModalPopup(false);
      setActiveType("Pan");
      setRemPan(payload?.panNumber);
      setRemIFSC("");
      setRemAccount("");
    };

    const handleClick = async () => {
      try {
        let updatedPayload = { ...payload, navigate };

        if (
          selectedFields.length === categories.length ||
          selectedFields.length === GlobalConfiguration.lengthCheckZero
        ) {
          updatedPayload.categories = null;
        } else {
          updatedPayload = {
            ...updatedPayload,
            categories: selectedFields.toString(),
          };
        }

        const data = await dispatch(
          createFieldForceAccount(updatedPayload),
        ).unwrap();

        const accountId = data.field_force_accounts[0].id;

        if (data?.status === true) {
          navigate(
            `/field_force_account_dashboard/create_field_force_account/success/${accountId}`,
            { replace: true },
          );
        }
      } catch (error) {
        navigate(
          `/field_force_account_dashboard/create_field_force_account/error`,
          { replace: true, state: error?.errors },
        );

        return error;
      }
    };

    const [isalertPopup, setAlertPopUp] = useState(false);

    return (
      <>
        {isalertPopup && (
          <div className="fixed z-z-index-max flex  items-center justify-center  top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle="Open in full view?"
              headerFontWeight="semibold"
              headerFontColor="emphasis"
              textSize="font-lg"
              subtext="Leaving this page will exit you from current flow."
              btnOneText="Cancel"
              btnOneHandleFunction={() => setAlertPopUp(false)}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoHandleFunction={() => {
                setAlertPopUp(false);
                navigate(
                  "/field_force_account_dashboard/field_force_account_view_all",
                );
              }}
              btnTwoEnabledBgColor="var(--text-primary)"
              btnTwoEnabledTextColor="var(--primary-bg)"
              btnTwoIsDisabled={false}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={true}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {showModalPopup && (
          <FieldForceAccountAssociatePopup
            handleClick={handleClick}
            handleCloseModal={handleCloseModal}
            showModalPopup={showModalPopup}
            createFieldForceAccountLoading={createFieldForceAccountLoading}
            accountNumber={payload.bank_account}
            ifsc={payload.ifsc_code}
            panNumber={payload.panNumber}
            setActiveType={setActiveType}
            setRemPan={setRemPan}
            setRemAccount={setRemAccount}
            setRemIFSC={setRemIFSC}
            remIFSC={remIFSC}
            remAccount={remAccount}
            remPan={remPan}
            activeType={activeType}
            isBottomRequired={true}
          />
        )}
        <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
          <CommonLayout>
            <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
              <div className="text-text-primary font-semibold text-font-md">
                PAN Details
              </div>
              <div className="flex flex-col gap-gap-sm">
                <div className="flex flex-col gap-gap-xs">
                  <div className="truncate capitalize font-normal text-text-primary text-font-md">
                    {payload?.panNumber}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    PAN number
                  </div>
                </div>
                <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
                <div className="flex flex-col gap-gap-xs">
                  <div className="w-width-full text-text-primary capitalize font-normal text-font-md text-wrap">
                    {payload?.legalName?.toLowerCase()}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    Legal name
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-button-l p-padding-md">
              <div className="flex flex-col gap-gap-md">
                <div className="text-text-primary text-font-md">
                  <span className="font-semibold">GST Details</span>
                  <span className="font-normal"> (Optional)</span>
                </div>

                <div className="flex flex-col gap-gap-sm">
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-width-full overflow-hidden truncate text-text-primary capitalize font-normal text-font-md">
                      {payload.gstin ? (
                        <span>{payload.gstin}</span>
                      ) : (
                        <span>Not Given</span>
                      )}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      GST number (optional)
                    </div>
                  </div>
                  {payload.gstin ? (
                    <>
                      <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
                      <div className="flex flex-col gap-gap-xs">
                        <div className="w-width-full overflow-hidden text-wrap text-text-primary capitalize font-normal text-font-md">
                          {payload.gstin
                            ? payload?.gst_org_name?.toLowerCase()
                            : null}
                        </div>
                        <div className="text-font-xs font-normal text-text-secondary">
                          {payload.gstin ? "Company name" : null}
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>

            {manualVirtualAccount && (
              <div>
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                  note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={manualVirtualAccount}
                  isPreview={true}
                />
              </div>
            )}

            <div className="flex flex-col bg-primary-card rounded-border-radius-md gap-gap-md p-padding-md">
              <div className="text-text-primary font-semibold text-font-md">
                Bank Details
              </div>
              <div className="flex flex-col gap-gap-sm">
                <div className="flex flex-col gap-gap-xs">
                  <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                    {formatAccountNumber(payload?.bank_account)}
                  </div>
                  <div className="text-font-xs font-normal text-text-secondary">
                    Bank account number
                  </div>
                </div>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-col gap-gap-xs">
                    <div className="text-text-primary font-normal capitalize text-font-md truncate">
                      {payload?.ifsc_code}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      IFSC code
                    </div>
                  </div>
                  <div className="flex justify-center items-center bg-text-primary rounded-full py-padding-button-s px-padding-sm">
                    <CommonBankLogo
                      ifsc={payload?.ifsc_code}
                      variant="big"
                    />
                  </div>
                </div>
                <>
                  <div className="bg-primary-bg h-[var(--border)] opacity-base-opacity my-margin-xs"></div>
                  <div className="flex flex-col gap-gap-xs">
                    <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                      {payload?.legalName?.toLowerCase()}
                    </div>
                    <div className="text-font-xs font-normal text-text-secondary">
                      Account holder's name
                    </div>
                  </div>
                  {bankUserInfo.length >= GlobalConfiguration.lengthCheckOne ? (
                    <>
                      <div className="flex flex-col gap-gap-xs">
                        <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate">
                          {bankUserInfo[GlobalConfiguration.lengthCheckZero]
                            .branch
                            ? bankUserInfo[GlobalConfiguration.lengthCheckZero]
                                .branch
                            : "NA"}
                        </div>
                        <div className="text-font-xs font-normal text-text-secondary">
                          Branch
                        </div>
                      </div>
                      <div className="flex flex-col gap-gap-xs">
                        <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate ">
                          {bankUserInfo[GlobalConfiguration.lengthCheckZero]
                            .city
                            ? bankUserInfo[GlobalConfiguration.lengthCheckZero]
                                .city
                            : "NA"}
                        </div>
                        <div className="text-font-xs  font-normal text-text-secondary">
                          City
                        </div>
                      </div>
                      <div className="flex flex-col gap-gap-xs">
                        <div className="w-width-full text-text-primary font-normal capitalize text-font-md truncate ">
                          {bankUserInfo[GlobalConfiguration.lengthCheckZero]
                            .district
                            ? bankUserInfo[GlobalConfiguration.lengthCheckZero]
                                .district
                            : "NA"}
                        </div>
                        <div className="text-font-xs  font-normal text-text-secondary">
                          District
                        </div>
                      </div>
                      <div className="flex flex-col gap-gap-xs">
                        <div
                          className="w-width-full text-text-primary  font-normal capitalize  text-font-md"
                          style={{
                            textWrap: "wrap",
                            wordWrap: "break-word",
                          }}
                        >
                          {bankUserInfo[GlobalConfiguration.lengthCheckZero]
                            .address
                            ? bankUserInfo[GlobalConfiguration.lengthCheckZero]
                                .address
                            : "NA"}
                        </div>
                        <div className="text-font-xs  font-normal text-text-secondary">
                          Address
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              </div>
            </div>

            <div className="flex flex-col gap-gap-md">
              <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
                <div>
                  <div className="text-text-primary font-semibold text-font-md">
                    Contact Details
                  </div>
                </div>
                <div className="rounded-b-large flex flex-col gap-gap-md">
                  <div className=" h-height-full rounded-b-large flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex flex-row items-center gap-gap-sm">
                        <div className="flex">
                          <img
                            className="w-icon-sm h-icon-sm flex-shrink-0"
                            src="https://q2pay.in/new_assets/common/create_flow/profile_unselected.svg"
                            alt="User"
                          />
                        </div>
                        <div className="w-width-full flex flex-col gap-gap-xs">
                          <div className="text-text-primary capitalize font-normal text-font-md">
                            {payload?.account_name?.toLowerCase()}
                          </div>
                          <div className="text-font-xs font-normal text-text-secondary">
                            {payload?.account_name?.toLowerCase() ==
                            payload?.legalName?.toLowerCase()
                              ? "Account name - Using legal name"
                              : "Account name"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" h-height-full rounded-b-large flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex flex-row items-center gap-gap-sm">
                        <div className="flex">
                          <img
                            className="w-icon-sm h-icon-sm flex-shrink-0"
                            src="https://q2pay.in/new_assets/common/create_flow/contact_with_white_circle.svg"
                            alt="Contact"
                          />
                        </div>
                        <div className="w-width-full flex flex-col gap-gap-xs">
                          <div className="overflow-hidden truncate text-text-primary font-normal capitalize text-font-md">
                            {"+91-"}
                            {payload?.contact_no}
                          </div>
                          <div className="text-font-xs font-normal text-text-secondary">
                            Contact Number
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=" h-height-full rounded-b-large flex flex-row">
                    <div className="flex flex-col">
                      <div className="flex flex-row items-center gap-gap-sm">
                        <div className="flex">
                          <img
                            className="w-icon-sm h-icon-sm flex-shrink-0"
                            src="https://q2pay.in/new_assets/common/create_flow/contact_us_mail.svg"
                            alt="Gmail"
                          />
                        </div>
                        <div className="w-width-full flex flex-col gap-gap-xs">
                          <div
                            id="crt-bene-acc-email-id-firstLetter"
                            className="overflow-hidden truncate text-text-primary font-normal text-font-md"
                          >
                            {linkIdentifier(payload?.email_id.toLowerCase())}
                          </div>
                          <div className="text-font-xs font-normal text-text-secondary">
                            Email ID
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
                <div className="text-text-primary text-font-md">
                  <span className="font-semibold">User</span>
                </div>
                <div>
                  <div className="text-text-primary text-font-md">
                    {payload.userName === "" ? (
                      <div className="mb-margin-xs">Not linked</div>
                    ) : (
                      <div className="mb-margin-xs">{payload.userName}</div>
                    )}
                  </div>
                  <div className="text-text-secondary text-font-xs font-normal">
                    User
                  </div>
                </div>
              </div>

              <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
                <div className="text-text-primary text-font-md">
                  <span className="font-semibold">Labels</span>
                  <span className="font-normal"> (Optional)</span>
                </div>
                <div>
                  <div className="text-text-primary text-font-md">
                    {payload?.labels?.length ===
                    GlobalConfiguration.lengthCheckZero ? (
                      <div className="mb-margin-xs">Not assigned</div>
                    ) : (
                      <div className="mb-margin-xs">
                        {payload?.labels?.map((item, index) => (
                          <span
                            key={index}
                            className="break-all"
                          >
                            {item}
                            {index <
                              payload.labels.length -
                                GlobalConfiguration.lengthCheckOne && ", "}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="text-text-secondary text-font-xs font-normal">
                    Labels
                  </div>
                </div>
              </div>

              {/* Delete this  */}
              <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
                <div className="text-text-primary text-font-md">
                  <span className="font-semibold">Recipients</span>
                  <span className="font-normal"> (Optional)</span>
                </div>
                <div>
                  <div className="text-text-primary text-font-md">
                    {recipients?.length ===
                    GlobalConfiguration.lengthCheckZero ? (
                      <div className="mb-margin-xs">Not assigned</div>
                    ) : (
                      <div className="mb-margin-xs overflow-hidden overflow-ellipsis">
                        {recipients?.map((item, index) => (
                          <span
                            key={index}
                            className="break-all"
                          >
                            {item}
                            {index <
                              recipients?.length -
                                GlobalConfiguration.lengthCheckOne && ", "}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="text-text-secondary text-font-xs font-normal">
                    Recipients
                  </div>
                </div>
              </div>
              {/* Delete this  */}
            </div>

            <div className="flex flex-col overflow-hidden bg-primary-card rounded-border-radius-md gap-gap-md py-padding-md w-width-full">
              <div className="px-padding-md">
                <div className="text-text-primary font-semibold text-font-md">
                  Categories
                </div>
              </div>
              <div className="overflow-auto max-h-category-popup-height px-padding-md bene-confirm-opactiy w-width-full">
                <div className="flex flex-col gap-gap-md w-width-full">
                  {selectedFields.map((categoryName, index) => (
                    <>
                      <div
                        className="bg-primary-nav rounded-border-radius-md flex w-width-full"
                        key={index}
                      >
                        <div className="p-padding-sm flex items-center bg-text-primary rounded-l-border-radius-md">
                          <img
                            className="h-icon-lg w-icon-lg flex-shrink-0"
                            src={ICONS?.DEFAULT_CATEGORY}
                            alt="bene"
                          />
                        </div>
                        <div className="w-full flex items-center pl-padding-sm min-w-0">
                          <p className="text-text-primary truncate text-font-sm font-semibold">
                            {categoryName}
                          </p>
                        </div>
                        <div className="px-padding-sm"></div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
          </CommonLayout>
        </div>
      </>
    );
  },
);

export default FieldForceConfirmAccount;
